// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2jfEm","right":"Footer_right__2eKAP","buttons":"Footer_buttons__1LVGl"};